import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "form-container" }
const _hoisted_2 = { class: "form-input col-2" }
const _hoisted_3 = ["value"]
const _hoisted_4 = {
  key: 0,
  class: "spinner-container"
}
const _hoisted_5 = { key: 1 }

import { ref, computed, onMounted } from 'vue';
	import { useRoute, useRouter } from 'vue-router';
	import axios from 'axios';
	import functions from '@/use/functions';
	import { DateOption, AnnualReview, AnnualReviewDetails } from '@/models/loans';
	import Spinner from '@/components/shared/Spinner.vue';
	import AnnualReviewDetailsComponent from '@/components/loan/annual-review/AnnualReviewDetails.vue';
	import CourtesyRepullDetails from '@/components/loan/annual-review/CourtesyRepullDetails.vue';

	
export default /*@__PURE__*/_defineComponent({
  __name: 'AnnualReviewTab',
  props: {
    loanId: {},
    lenderId: {},
    productTypeId: {},
    programTypeId: {},
    referenceId: {},
    applicationUrl: {},
    annualReviews: {}
  },
  setup(__props: any) {

	const props = __props;

	const route = useRoute();
	const router = useRouter();

	const isLoading = ref<boolean>(false);
	const selectedAnnualReviewId = ref<number>();
	const annualReviewDetails = ref<AnnualReviewDetails | null>();

	const yearOptions = computed<DateOption[]>(() => {
		return props.annualReviews.map(
			(review): DateOption => ({
				id: review.id,
				name: review.annualReviewYear.toString()
			})
		);
	});

	const selectInitialAnnualReview = () => {
		const queryAnnualReviewId = Number(route.query.annualReviewId);

		if (isNaN(queryAnnualReviewId) || !props.annualReviews.some((review) => review.id === queryAnnualReviewId)) {
			selectedAnnualReviewId.value = yearOptions.value[0].id;
		} else {
			selectedAnnualReviewId.value = queryAnnualReviewId;
		}
	};

	const onSelectedYearChangeAsync = async () => {
		if (!selectedAnnualReviewId.value) {
			return;
		}

		router.replace({
			query: { ...route.query, annualReviewId: selectedAnnualReviewId.value },
			hash: route.hash
		});

		await fetchAnnualReviewDataAsync();
	};

	const fetchAnnualReviewDataAsync = async () => {
		isLoading.value = true;
		annualReviewDetails.value = null;

		try {
			const response = await axios(`/api/annualreview/${selectedAnnualReviewId.value}`);

			annualReviewDetails.value = response.data;
		} catch (error) {
			const review = props.annualReviews.find((r) => r.id === selectedAnnualReviewId.value);
			const reviewYear = review ? review.annualReviewYear : 'Unknown';

			functions.openModal({
				title: 'Oops!',
				description: `There was an issue getting the data for annual review year ${reviewYear}. Please try again later.`
			});
		} finally {
			isLoading.value = false;
		}
	};

	onMounted(async () => {
		selectInitialAnnualReview();

		await fetchAnnualReviewDataAsync();
	});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _cache[1] || (_cache[1] = _createElementVNode("label", null, " Annual Review Year ", -1)),
        _withDirectives(_createElementVNode("select", {
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedAnnualReviewId).value = $event)),
          onChange: onSelectedYearChangeAsync
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(yearOptions.value, (option) => {
            return (_openBlock(), _createElementBlock("option", {
              key: option.id,
              value: option.id
            }, _toDisplayString(option.name), 9, _hoisted_3))
          }), 128))
        ], 544), [
          [_vModelSelect, selectedAnnualReviewId.value]
        ])
      ])
    ]),
    (isLoading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createVNode(Spinner)
        ]))
      : (selectedAnnualReviewId.value && annualReviewDetails.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createVNode(AnnualReviewDetailsComponent, {
              loanId: __props.loanId,
              lenderId: __props.lenderId,
              productTypeId: __props.productTypeId,
              programTypeId: __props.programTypeId,
              referenceId: __props.referenceId,
              applicationUrl: __props.applicationUrl,
              annualReviewDetails: annualReviewDetails.value,
              selectedAnnualReviewId: selectedAnnualReviewId.value,
              onReloadAnnualReviewAsync: fetchAnnualReviewDataAsync
            }, null, 8, ["loanId", "lenderId", "productTypeId", "programTypeId", "referenceId", "applicationUrl", "annualReviewDetails", "selectedAnnualReviewId"]),
            (annualReviewDetails.value.hasCourtesyRepull)
              ? (_openBlock(), _createBlock(CourtesyRepullDetails, {
                  key: 0,
                  loanId: __props.loanId,
                  lenderId: __props.lenderId,
                  productTypeId: __props.productTypeId,
                  programTypeId: __props.programTypeId,
                  referenceId: __props.referenceId,
                  applicationUrl: __props.applicationUrl,
                  annualReviewDetails: annualReviewDetails.value,
                  selectedAnnualReviewId: selectedAnnualReviewId.value,
                  onReloadAnnualReviewAsync: fetchAnnualReviewDataAsync
                }, null, 8, ["loanId", "lenderId", "productTypeId", "programTypeId", "referenceId", "applicationUrl", "annualReviewDetails", "selectedAnnualReviewId"]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
  ]))
}
}

})